import {
  OPERATOR_USER_MENU_SECTIONS,
  USER_TOP_NAV_SECTIONS,
} from './shellMenuLayout'

const SIDEBAR_MENU_AUDIENCE = 'user-dropdown'

/** 사이드바용 사용자 메뉴 섹션 — 운영자는 확장 그룹 + visibilityKey 보정 */
export function resolveSidebarUserSections(isOperator) {
  if (!isOperator) {
    return USER_TOP_NAV_SECTIONS.map((section) => ({
      ...section,
      audience: SIDEBAR_MENU_AUDIENCE,
    }))
  }
  return OPERATOR_USER_MENU_SECTIONS.map((section) => {
    const base = USER_TOP_NAV_SECTIONS.find((s) => s.id === section.id)
    return {
      ...section,
      visibilityKey: base?.visibilityKey || 'always',
    }
  })
}

export { SIDEBAR_MENU_AUDIENCE }
